import React from "react";
//#region types
import { CurrencyEnums } from "models/enums";
import { PaymentsTodoSelectionPanelProps } from "models/propTypes/todoSelectionPanelPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region component
import { FooterWithDivider, TitleWithDescription, TitledContainerInner } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const PausedPaymentsTodoSelection: React.FC<PaymentsTodoSelectionPanelProps> = (props) => {
  return (
    <TitledContainerInner
      header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.PausedPaymentsHeader)}
      subHeader={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Payments.PausedSelectionPanelDescription
      )}
    >
      <FooterWithDivider>
        <TitleWithDescription
          title={`${LocalizationHelperInstance.getFormattedCurrency(props.selectedPaymentsTotal)} ${
            CurrencyEnums.CurrencyCode.SEK
          }`}
          subTitle={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.PausedPaymentsMarked, "", {
            selectedPayments: props.selectedPaymentsCount.toString(),
          })}
          helpText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Payments.PaymentsTooltipMessage)}
        />
      </FooterWithDivider>
    </TitledContainerInner>
  );
};

export default PausedPaymentsTodoSelection;
